<template>
	<drawer
			title="Settings"
			@updateClose="onDrawerClose"
			@updateSave="onSave"
	>
		<div class="sub_title">
			<span>Display column</span>
		</div>
		<div class="list-group-item">
			<v-checkbox
					class="checkbox"
					label="Select all"
					color="success"
					hide-details
					v-model="all"
					@click="onAll"
			></v-checkbox>
		</div>
		<draggable
				:list="settings"
				class="list-group"
				handle=".handle"
				v-bind="dragOptions"
				@start="onStart"
				@end="onEnd"
		>
			<transition-group
					type="transition"
					:name="!drag ? 'flip-list' : null"
			>
				<div
						class="list-group-item handle"
						v-for="(element, idx) in settings"
						:key="getName(element.text) + (element.value || idx)"
				>
					<v-checkbox
							class="checkbox"
							:input-value="element.settings"
							:label="getName(element.text)"
							color="success"
							hide-details
							v-model="element.settings"
					></v-checkbox>
					<span class="icon">
                  <svg-sprite
		                  :width="14"
		                  :height="8"
		                  icon-id="icon_draggable"
                  ></svg-sprite>
                </span>
				</div>
			</transition-group>
		</draggable>
	</drawer>
</template>

<script>
import draggable from "vuedraggable";
import Drawer from "@/shared/Drawer/Drawer.vue";

export default {
	name: "TableSettings",
	components: { Drawer, draggable },
	props: { settings: Array },
	computed: {
		dragOptions() {
			return {
				animation: 200,
				group: "description",
				disabled: false,
				ghostClass: "ghost",
			};
		},
	},
	data: () => ({
		all: false,
		dragging: false,
		drag: false,
	}),
	methods: {
		onStart() {
			this.drag = true;
		},
		onEnd() {
			this.drag = false;
			this.$store.dispatch('doDragSettings', this.settings);
		},
		getName(value) {
			return value ? value : "Buttons";
		},
		onDrawerClose(type) {
			if ( type == "close" || type == "outside" ) this.onClose();
			if ( type == "cancel" ) this.onCancel();
		},
		onClose() {
			this.$emit("updateSettingsClose");
		},
		onCancel() {
			this.$emit("updateSettingsCancel");
		},
		onAll() {
			this.$emit("updateSettingsAll", this.all);
		},
		onSave() {
			this.$emit("updateSettingsSave");
			this.onClose();
		},
	},
};
</script>
<style lang="scss">
@import "tableSettings";
</style>
